import { render, staticRenderFns } from "./recontact.vue?vue&type=template&id=3c7dc410&scoped=true"
import script from "./recontact.vue?vue&type=script&lang=ts"
export * from "./recontact.vue?vue&type=script&lang=ts"
import style0 from "./recontact.vue?vue&type=style&index=0&id=3c7dc410&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7dc410",
  null
  
)

export default component.exports